import {ActionReducer, ActionReducerMap, createFeatureSelector} from '@ngrx/store';
import * as fromAvailabilities from './availability.reducer';
import {combineReducers} from '@ngrx/store';

export interface AvailabilitiesState {
  availabilities: fromAvailabilities.AvailabilityState;
}

export const reducers: ActionReducerMap<AvailabilitiesState> = {
  availabilities: fromAvailabilities.reducer,
};

export const reducer: ActionReducer<AvailabilitiesState> = combineReducers(reducers);

export const getAvailabilitiesState = createFeatureSelector<AvailabilitiesState>('availabilitiesFeature');



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/availabilities/store/reducers/index.ts